
// import Plotly from "plotly.js-dist"

const StatistiquesGestion = function(element, options) {
    this.element = $(element);
    this.form = this.element.find('form');
    this.table = this.element.find('[data-stats-table]');

    this.container = this.element.find('[data-stats-chart]');
    this.chart = this.container[0];
    this.card = this.container.closest('.card');

    // Default data
    this.categories = options.categories;
    this.charts = options.charts;

    this.table.on('change', 'input[type=checkbox]', event => {
        const element = $(event.currentTarget);

        if (element.prop('checked')) {
            this.loadChart(element.val());
        } else {
            this.unloadChart(element.val());
        }
    });

    setTimeout(() => {
        this.initChart();
    }, 100);
};

$.extend(StatistiquesGestion.prototype, {
    startLoading: function() {
        this.card.addClass('stats-gestion-loading');
    },
    stopLoading: function() {
        this.card.removeClass('stats-gestion-loading');
    },

    initChart: function() {
        const config = {
            locale: 'fr',
            responsive: true,
            displayModeBar: false
        };

        Plotly.newPlot(
            this.chart,
            this.makeTraces(this.charts),
            this.makeLayout(this.charts),
            config
        );

        this.stopLoading();
    },

    updateChart: function() {
        setTimeout(() => {
            Plotly.react(
                this.chart,
                this.makeTraces(this.charts),
                this.makeLayout(this.charts)
            );

            this.stopLoading();
        }, 10);
    },

    makeTraces: function(charts) {
        const traces = []

        $.each(charts, (name, chart) => {
            if (undefined !== chart.display && !chart.display) {
                return;
            }

            $.each(chart.traces, (index, trace) => {
                traces.push(this.makeTrace(trace, chart.type));
            });
        });

        return traces;
    },

    makeTrace: function(chart, type) {
        const trace = {
            x: this.categories,
            y: chart.data,
            name: chart.name,
            type: 'scatter',
            mode: 'lines+markers'
        };

        switch (type) {
            case 'weight' :
                trace.hovertemplate = '%{y:,} Kg';
                trace.yaxis = 'y2';
                break;
            case 'percent' :
                trace.hovertemplate = '%{y:.1f}%';
                trace.yaxis = 'y3';
                break;
            case 'days' :
                trace.hovertemplate = '%{y:,} jour(s)';
                trace.yaxis = 'y4';
                break;
            case 'money' :
            default :
                trace.hovertemplate = '%{y:,} €';
                break;
        }

        return trace;
    },

    getDataTypes: function(charts) {
        const types = [];

        $.each(charts, (name, chart) => {
            if (!types.includes(chart.type)) {
                types.push(chart.type);
            }
        });

        return types;
    },

    makeLayout: function(charts) {
        const layout = {
            xaxis: {
                type: 'category',
                domain: [ 0, 1 ]
            },
            yaxis: {
                title: 'Montant',
                visible: true
            },
            margin: {
                t: 0
            }
        };

        const types = this.getDataTypes(charts);
        let xaxisDomain = layout.xaxis.domain[1];
        let nextYaxisPosition = 1;

        if (types.includes('weight')) {
            layout.yaxis2 = {
                title: 'Volume',
                side: 'right',
                overlaying: 'y',
                scaleanchor: 'y',
                anchor: 'free',
                position: nextYaxisPosition
            };

            xaxisDomain -= 0.05;
            nextYaxisPosition -= 0.05;
        }
        if (types.includes('percent')) {
            layout.yaxis3 = {
                title: 'Pourcentage',
                side: 'right',
                overlaying: 'y',
                anchor: 'free',
                position: nextYaxisPosition
            }

            xaxisDomain -= 0.05;
            nextYaxisPosition -= 0.05;
        }
        if (types.includes('days')) {
            layout.yaxis4 = {
                title: 'Jour(s)',
                side: 'right',
                overlaying: 'y',
                anchor: 'free',
                position: nextYaxisPosition
            }

            xaxisDomain -= 0.05;
            nextYaxisPosition -= 0.05;
        }

        layout.xaxis.domain[1] = xaxisDomain;

        return layout;
    },

    unloadChart: function(chart) {
        this.startLoading();

        if (undefined !== this.charts[chart]) {
            this.charts[chart].display = false;
        }

        this.updateChart();
    },

    loadChart: function(chart) {
        this.startLoading();

        if (undefined !== this.charts[chart]) {
            this.charts[chart].display = true;

            this.updateChart();
        } else {
            $.ajax({
                url: Routing.generate('stats_gestion_chart', {
                    chart: chart
                }),
                data: this.form.serializeArray(),
                success: response => {
                    $.extend(this.charts, response);

                    this.updateChart();
                }
            })
        }
    }
});

$.fn.statistiquesGestion = function(options) {
    return $.each(this, function () {
        new StatistiquesGestion(this, options);
    })
};


// WEBPACK FOOTER //
// ./js/form/statsGestion.js